export default __webpack_public_path__ + "static/challenger-6bfabd519b09db11c0315d43a1ff80e4.png";